import {useTranslation} from 'react-i18next';
import {Authorize} from '@postinumero/authorization';
import Page from '../../Page';
import Forbidden from '../Forbidden';
import Layout from './Layout';
import {useParams} from "react-router-dom";
import LayoutSingle from "./LayoutSingle";

export default function CorporateActions() {
  const [t] = useTranslation();
  const {id} = useParams();

  return (
    <Page title={t("events.title")}>
      <Authorize allow={['Issuer agent', 'Account operator', 'Inspector']} fallback={<Forbidden/>}>
        {id ? <LayoutSingle id={id}/> : <Layout/>}
      </Authorize>
    </Page>
  );
}
